<template>
    <div class="page-header signup-page header-filter" filter-color="orange">
        <div class="page-header-image"
             style="background-image: url('img/homepage/loginHero2.jpg')">
        </div>
        <div class="content">
            <div class="container">
                <div class="row">
              <div class="col-md-6 ml-auto mr-auto">
                        <div class="info info-horizontal">
                            <!-- <div class="icon icon-primary">
                                <i class="now-ui-icons media-2_sound-wave"></i>
                            </div> -->
                            <div class="description">
                                <h5 class="info-title">The System Apprentice Package - Weekly Subscription
                                  <br>A$18.99/week
                                </h5>
                                <p class="description">
                                     A weekly subscription to The System
                                </p>
                                      <div>
                                        <n-button  @click.native="checkoutStripe('price_1ITUQKKdbJJr9GC2GHPENg9n')" type="primary">Subscribe Now!</n-button>
                                    </div>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <!-- <div class="icon icon-primary">
                                <i class="now-ui-icons media-1_button-pause"></i>
                            </div> -->
                            <div class="description">
                                <h5 class="info-title">The System Presidential Package - Monthly Subscription
                                   <br> A$69.99/ Month</h5>
                                <p class="description">
                                    1 Month Subscription to The System - equates to $16.15 per week!
                                </p>
                                <div>
                                        <n-button  @click.native="checkoutStripe('price_1ITUQjKdbJJr9GC24eUf4Mko')" type="primary">Subscribe Now!</n-button>
                                    </div>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <!-- <div class="icon icon-info">
                                <i class="now-ui-icons users_single-02"></i>
                            </div> -->
                            <div class="description">
                                <h5 class="info-title">The System Deluxe Package - 3 Months Subscription
                                <br> A$194.99/ 3 Months
                                </h5>
                                <p class="description">
                                    A 3 Monthly Subscription to The System - equates to $14.99 per week!
                                </p>
                                <div>
                                        <n-button  @click.native="checkoutStripe('price_1ITUPLKdbJJr9GC2pl64sh3A')" type="primary">Subscribe Now!</n-button>
                                    </div>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <!-- <div class="icon icon-info">
                                <i class="now-ui-icons users_single-02"></i>
                            </div> -->
                            <div class="description">
                                <h5 class="info-title">The System Executive Package - 6 Months Subscription
                                <br> A$349.99/ 6 Months
                                </h5>
                                <p class="description">
                                   A 6 Monthly Subscription to The System - equates to $13.46 per week!
                                </p>
                                <div>
                                        <n-button  @click.native="checkoutStripePayment('price_1ITUULKdbJJr9GC2JM0PrKYm')" type="primary">Subscribe Now!</n-button>
                                    </div>
                            </div>
                        </div>
                    </div>
                <div class="col-md-4 ml-auto mr-auto">
                    <card type="login" plain>
                        <div slot="header" class="logo-container">
                            <!-- <img v-lazy="'img/homepage/logo.png'" alt=""> -->
                            Login
                        </div>


                        <fg-input class="no-border input-lg"
                                  v-model="email"
                                  addon-left-icon="now-ui-icons users_circle-08"
                                  placeholder="Email...">
                        </fg-input>

                        <fg-input class="no-border input-lg"
                                  v-model="password"
                                  type="password"
                                  addon-left-icon="now-ui-icons text_caps-small"
                                  placeholder="Password...">
                        </fg-input>

                        <template slot="raw-content">
                            <div class="card-footer text-center">
                                <a @click="login()" class="btn btn-primary btn-round btn-lg btn-block">Login</a>
                            </div>
                            <!-- <div class="card-footer text-center">
                                <a href="/#/membersRegisteration" class="btn btn-neutral btn-round btn-lg btn-block">Create Account</a>
                            </div> -->
                            <br>
                            <div class="pull-center">
                                <h6>
                                    <a href="/#/membersRegisteration" class="link footer-link">Create Account</a>
                                </h6>
                            </div>
                            <!-- <div class="pull-right">
                                <h6>
                                    <a href="#pablo" class="link footer-link">Need Help?</a>
                                </h6>
                            </div> -->
                        </template>
                    </card>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput } from '@/components';
  import MainFooter from '@/layout/MainFooter';
  import db from '../../components/Firebase/firebaseInit'
  import firebase from 'firebase';
  import { loadStripe } from "@stripe/stripe-js"

  export default {
    name: 'login-page',
    bodyClass: 'login-page',
    components: {
      Card,
      MainFooter,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
        return {
        email: '',
        password: '',
        loading: false,
    };
  },
    methods: {
    async checkoutStripe(price_id){
        this.loginButton = true;

        var createCheckoutSession = function(priceId) {
          return fetch("https://us-central1-aightbetnow-com.cloudfunctions.net/createCheckoutSession", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              priceId: priceId
            })
          }).then(function(result) {
            return result.json();
          });
        };

       let ider = price_id;
       const stripe = await loadStripe('pk_live_51IN97OKdbJJr9GC2Qi97mYou5pY79RL215MwTV6iKre9BTcno9IrRQwIiA2ioW1YHoVWc3mNz3UnK0IfqPu8Mmzv00WrQPMeQm');

        // You'll have to define PRICE_ID as a price ID before this code block
        createCheckoutSession(ider).then(function(data) {
          // Call Stripe.js method to redirect to the new Checkout page
                stripe
                  .redirectToCheckout({
                    sessionId: data.sessionId
                  })
                  // .then(handleResult);
          });
    },
    async checkoutStripePayment(price_id){
        this.loginButton = true;

        var createCheckoutSession = function(priceId) {
          return fetch("https://us-central1-aightbetnow-com.cloudfunctions.net/createCheckoutSessionPayment", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              priceId: priceId
            })
          }).then(function(result) {
            return result.json();
          });
        };

       let ider = price_id;
       const stripe = await loadStripe('pk_live_51IN97OKdbJJr9GC2Qi97mYou5pY79RL215MwTV6iKre9BTcno9IrRQwIiA2ioW1YHoVWc3mNz3UnK0IfqPu8Mmzv00WrQPMeQm');

        // You'll have to define PRICE_ID as a price ID before this code block
        createCheckoutSession(ider).then(function(data) {
          // Call Stripe.js method to redirect to the new Checkout page
                stripe
                  .redirectToCheckout({
                    sessionId: data.sessionId
                  })
                  // .then(handleResult);
          });
    },
    login () {
    //   let stats = this.$store.state.models;
    //   stats.logedIn == true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            // console.log(user);
            // alert(`You are logged in as ${this.email}`);
            this.$store.state.models.logedIn = true;
            this.$router.push('/evPunting');
             

          },
          err => {
            alert(err.message);
          }
        );
    //   e.preventDefault();
    }
  }
  }
</script>
<style scoped>
.page-header{
max-height: 9999px !important;
}
</style>
